import AuditTrail from "../audit.trail";

export const SelectLog = (WrappedComponent) => (props) => {
  const { onChange, onClick, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          AuditTrail.sendLog(event, Object.assign({tag: 'select', event: action, label: props.label? props.label : (props.placeholder? props.placeholder : ''), value: props.value}, eventParams));
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onChange={(context) => {
            onLog(event, 'onChange', eventParams);
            if (props.onChange) {
                props.onChange(context);
            }
        }}
        onClick={(context) => {
            let _eventParams = Object.assign({}, eventParams);
            _eventParams.open = context;
            onLog(event, 'onClick', _eventParams);
            if (props.onClick) {
                props.onClick(context);
            }
        }}
    />
  );
};
